<template>
    <v-container class="container">
        <h3 class="titulo mb-3">CONFIGURAÇÃO CARRINHO DE COMPRAS</h3>
        <v-card>
            <v-card-text>
                <div class="funcionalidade-container">
                    <v-row>
                        <v-col cols="12" class="d-flex">
                            <h4 class="parametros__sistema__h4">
                                Configuração do carrinho de compras para o fluxo de vendas
                            </h4>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="10" style="display: inline-flex">
                            <v-radio-group
                                    v-model="Options.EtapaMultiplicadorCotaFluxoVenda"
                                    row
                                    style="margin-top: 7px; margin-right: -20px; padding-top: 0"
                            >
                                <v-radio label="Desabilitar" :value="0"></v-radio>
                                <v-radio label="Habilitar" :value="1"></v-radio>
                                <v-radio label="Habilitar para" :value="2"></v-radio>
                            </v-radio-group>
                            <div
                                    class="div--comboBox"
                                    :style="{ 'margin-bottom': isEnabled.EtapaMultiplicadorCotaFluxoVenda ? '-26px !important' : '' }"
                            >
                                <DynamicSelect
                                        placeholder="Selecione os usuários"
                                        v-model="usuariosSelecionados.EtapaMultiplicadorCotaFluxoVenda"
                                        endpoint="/dynamic-selects/usuarios/id"
                                        :class="{ isDisabled: !isEnabled.EtapaMultiplicadorCotaFluxoVenda, comboBoxEnorme: true }"
                                        :disabled="!isEnabled.EtapaMultiplicadorCotaFluxoVenda"
                                />
                            </div>
                        </v-col>
                    </v-row>
                </div>
                <v-row>
                    <v-col cols="10" class="mt-7"></v-col>
                    <v-col cols="2" class="mt-7">
                        <v-btn class="transition button-right" color="primary" rounded @click="salvarFuncionalidadesDoSistema">
                            Salvar
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
  import { notification } from '@/plugins/helpers'
  import { ValuesFunctionalities } from '@/plugins/constants'
  import { AlertTypes } from '../../../plugins/alerts_types'

  export default {
    name: 'ConfiguracoesCarrinho',
    data: () => ({
      OptionsEach: ['EtapaMultiplicadorCotaFluxoVenda'],
      Options: {
        EtapaMultiplicadorCotaFluxoVenda: 0
      },
      usuariosSelecionados: {
        EtapaMultiplicadorCotaFluxoVenda: []
      },
      isEnabled: {
        EtapaMultiplicadorCotaFluxoVenda: false
      },
      NomeColunas: {
        EtapaMultiplicadorCotaFluxoVenda: 'habilitar_etapa_multiplicador_cota'
      },
      NomeFuncionalidade: {
        EtapaMultiplicadorCotaFluxoVenda: 'EtapaMultiplicadorCotaFluxoVenda'
      }
    }),
    watch: {
      'Options.EtapaMultiplicadorCotaFluxoVenda' () {
        this.isEnabled.EtapaMultiplicadorCotaFluxoVenda = this.Options.EtapaMultiplicadorCotaFluxoVenda === ValuesFunctionalities.HABILITAR_PARA
      }
    },
    mounted () {
      Promise.all([this.SetarDadosFuncionalidades()])
    },
    methods: {
      async SetarDadosFuncionalidades () {
        try {
          await this.$http.post('/painel/configuracao/restricoes_carrinho/get', { nome_colunas: this.NomeColunas }).then(response => {
            let data = response.data.restricoes
            data.forEach(dado => {
              this.Options[dado.funcionalidade] = dado.config
              this.usuariosSelecionados[dado.funcionalidade] = JSON.parse(dado.usuarios)
            })
          })
        } catch (e) {
          console.error(e)
          notification(AlertTypes.ERROR, 'Erro ao consultar as configurações das funcionalidades no painel administrativo.')
        }
      },
      limparCampos () {
        this.OptionsEach.forEach(option => {
          if (this.Options[option] !== ValuesFunctionalities.HABILITAR_PARA && this.usuariosSelecionados[option].length > 0) {
            this.usuariosSelecionados[option] = []
          }
        })
      },
      async salvarFuncionalidadesDoSistema () {
        if ((this.Options.EtapaMultiplicadorCotaFluxoVenda === ValuesFunctionalities.HABILITAR_PARA && this.usuariosSelecionados.EtapaMultiplicadorCotaFluxoVenda.length === 0)) {
          notification(AlertTypes.WARN, 'Necessário informar ao menos 1 usuário para acesso das funcionalidades listadas.')
          return
        }

        this.limparCampos()

        try {
          await this.$http.post('/painel/configuracao/restricoes_carrinho/salvar', {
            options: this.Options,
            usuarios: this.usuariosSelecionados,
            nome_funcionalidade: this.NomeFuncionalidade,
            nome_colunas: this.NomeColunas
          })
          notification(AlertTypes.SUCCESS, 'Configuração atualizada com sucesso!')
        } catch (e) {
          notification(AlertTypes.ERROR, 'Não foi possível atualizar a configuração, tente novamente mais tarde!')
        }
      }
    }
  }
</script>

<style scoped>
.v-card__text {
  margin-top: 8px;
}

.row {
  align-items: center;
}

.v-input__control {
  align-items: center;
  justify-items: center;
}

.v-input {
  display: flex;
  align-items: center;
}

.v-input--selection-controls {
  margin-top: 1.5rem;
}

.mt-7 {
  align-self: flex-end;
}

.div--comboBox {
  width: 65%;
}

.comboBoxEnorme {
  max-width: 100%;
  margin-bottom: 0px !important;
  margin: 16px !important;
}

.parametros__sistema__h4 {
  margin-top: 15px;
  margin-bottom: 15px;
}

.isDisabled {
  overflow: hidden !important;
  border-radius: 10px;
  background-color: #efefef !important;
}
</style>
